var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-table',{ref:"app_table_ref",attrs:{"table-key":_vm.table_key,"tablep":_vm.table_params,"get-data":_vm.getStarTasksList,"table-props":{ 'max-height': '450px'},"check":true,"check-key":"id","is-reserve-checked":true,"is-row-click":true},on:{"select-tr":_vm.selectionChange,"hook:mounted":_vm.onTableMounted}})
}
var staticRenderFns = []

export { render, staticRenderFns }